/**
 * Created by Carsten Bühler
 * User: CBuehler on 11.02.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React, { useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';
import { CustomModal, CustomModalBody, Title } from 'plugin/liferay-widgets-react-web';
import '../css/_imagedisplay.scss';

const cacheBusting = {};

const ImageDisplay = React.forwardRef(({ className = '', onClick, previewUrl, thumbnailUrl }, ref) => {
    const [ openedImageModal, setOpenedImageModal ] = useState(false);

    const openImageModal = () => setOpenedImageModal(true);

    const closeImageModal = () => setOpenedImageModal(false);

    if (!ref) {
        ref = React.createRef();
    }

    const onError = (e) => {
        if (!cacheBusting[e.currentTarget.src]) {
            console.log(`Img load error ${e.currentTarget.src} try cache busting`);
            cacheBusting[e.currentTarget.src] = true;
            fetch(e.currentTarget.src, { cache: 'reload', mode: 'no-cors' }).then(
                () => {
                    console.info('cache busted!');
                    if (ref.current && ref.current.src.indexOf('#1') === -1) {
                        ref.current.src = ref.current.src + '#1';
                    }
                }
            );
        } else {
            console.error(`Img load error ${e.currentTarget.src} cache already busted`);
        }
    };

    return (
        <div className={`image-display ${className}`}>
            <Button variant="link" onClick={onClick || (previewUrl && openImageModal)}>
                <img
                    onError={onError}
                    ref={ref}
                    src={thumbnailUrl || previewUrl}
                    title="Vergrößern"
                    loading="lazy"
                />
            </Button>
            <CustomModal
                show={openedImageModal}
                onHide={closeImageModal}
                size="xl"
            >
                <Title title="Vorschau"/>

                <CustomModalBody>
                    <img src={previewUrl} className="w-100" loading="lazy"/>
                </CustomModalBody>

            </CustomModal>
        </div>
    );
});
ImageDisplay.displayName = 'ImageDisplay';

ImageDisplay.propTypes = {
    thumbnailUrl: PropTypes.string,
    previewUrl: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string
};

export default ImageDisplay;



// WEBPACK FOOTER //
// ./js/components/ImageDisplay.jsx